var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HeaderWeb'),_c('CarouselHome'),_c('ItemCarousel'),_c('InstaGallery'),_c('PartnerLogo'),_c('FooterWeb',{attrs:{"shopName":"Arishoppppp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }